import React from "react";
import NoDataFound from "../reuseableComponents/NoDataFound";
import Skeleton from "react-loading-skeleton";

export const CommonTable = ({
  isShow,
  childHeader,
  childrenBody,
  childFooter,
  loading,
  tablevalue,
  bottomPagination,
  topPagination,
  isPaginationShow,
}) => {
  return (
    <div className="commonTable">
      <div className={`table-container `}>
        <div className="common-table-pagination">
          {isPaginationShow ? topPagination : null}
        </div>
        <div style={{ width: "100%", maxWidth: "100%", overflowX: "auto" }}>
          <table
            className="table-overflow"
            style={{ minWidth: "100%", width: "max-content" }}
          >
            <thead className="table-header">
              <tr className="tableStickyHead">{isShow ? childHeader : null}</tr>
            </thead>

            {loading ? (
              <tbody className="table-body">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((row) => (
                  <tr key={row}>
                    {childHeader.map((col) => (
                      <td key={col}>
                        <Skeleton />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            ) : (
              <>
                <tbody className="table-body">
                  {isShow ? childrenBody : null}
                </tbody>
                {childrenBody?.length > 0 && (
                  <tfoot className="table-footer">
                    {isShow ? childFooter : null}
                  </tfoot>
                )}
              </>
            )}
          </table>
        </div>
        {!childrenBody?.length > 0 && !loading && (
          <NoDataFound table={!tablevalue ? tablevalue : true} />
        )}
        <div
          className={`common-table-pagination ${
            !isPaginationShow ? "mt-3" : "mt-0"
          }`}
        >
          {isPaginationShow ? bottomPagination : null}
        </div>
      </div>
    </div>
  );
};

export default CommonTable;
